import { SvgIcon, SvgIconProps } from '@mui/material';

export function DocWithMagnifyingGlassIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 500 500'
    >
      <g filter='url(#filter0_i_511_99)'>
        <rect
          width='500'
          height='500'
          rx='250'
          fill='#F0F5FF'
        />
        <g filter='url(#filter1_d_511_99)'>
          <path
            d='M155.291 99.9999C147.891 100.896 147.328 105.46 147.02 114.387V346.637C146.72 357.029 149.723 360.115 161.495 359.997H339.081C339.251 359.997 339.423 359.975 339.587 359.931C346.416 358.104 348.809 355.34 349.677 346.637V164.488C349.677 163.99 349.492 163.511 349.157 163.142L292.37 100.655C291.991 100.238 291.454 99.9999 290.89 99.9999H155.291Z'
            fill='white'
          />
          <path
            d='M155.291 99.9999C147.891 100.896 147.328 105.46 147.02 114.387V346.637C146.72 357.029 149.723 360.115 161.495 359.997H339.081C339.251 359.997 339.423 359.975 339.587 359.931C346.416 358.104 348.809 355.34 349.677 346.637V164.488C349.677 163.99 349.492 163.511 349.157 163.142L292.37 100.655C291.991 100.238 291.454 99.9999 290.89 99.9999H155.291Z'
            stroke='white'
            fill='none'
          />
        </g>
        <path
          d='M349.677 163.464L294.402 102.047V153.396C296.137 161.313 298.79 163.438 306.039 163.464H349.677Z'
          fill='#C5DCFB'
          stroke='#C5DCFB'
        />
        <rect
          x='167'
          y='126.001'
          width='116'
          height='10'
          rx='2'
          fill='#3E8FFA'
        />
        <rect
          x='167'
          y='152'
          width='54'
          height='10'
          rx='2'
          fill='#3E8FFA'
        />
        <rect
          x='167'
          y='182.001'
          width='162'
          height='10'
          rx='5'
          fill='#DFEAFB'
        />
        <rect
          x='167'
          y='216'
          width='162'
          height='10'
          rx='5'
          fill='#DFEAFB'
        />
        <rect
          x='167'
          y='250'
          width='162'
          height='10'
          rx='5'
          fill='#DFEAFB'
        />
        <rect
          x='167'
          y='284'
          width='100'
          height='10'
          rx='5'
          fill='#DFEAFB'
        />
        <g filter='url(#filter2_d_511_99)'>
          <path
            d='M348.397 321.263C340.765 349.349 311.613 365.876 283.284 358.178C254.956 350.48 238.178 321.472 245.81 293.386C253.442 265.3 282.594 248.773 310.923 256.471C339.251 264.17 356.029 293.178 348.397 321.263Z'
            fill='#3E8FFA'
          />
          <path
            d='M338.258 339.275L357.134 359.958L344.041 371.72L325.165 351.037L338.258 339.275Z'
            fill='#3E8FFA'
          />
          <path
            d='M346.595 361.127C350.759 357.386 357.194 357.705 360.967 361.84L390.005 393.659C393.778 397.794 393.462 404.178 389.298 407.919C385.134 411.659 378.699 411.34 374.926 407.206L345.888 375.386C342.115 371.251 342.431 364.867 346.595 361.127Z'
            fill='#1F477D'
          />
          <path
            d='M354.824 358.11C356.609 356.404 359.45 356.457 361.17 358.23C362.889 360.002 362.836 362.821 361.051 364.527L349.522 375.546C347.737 377.252 344.896 377.198 343.176 375.426C341.456 373.654 341.51 370.834 343.295 369.128L354.824 358.11Z'
            fill='#1F477D'
          />
        </g>
        <rect
          x='-0.279253'
          y='5.62775'
          width='55.3482'
          height='12.2701'
          rx='6.13503'
          transform='matrix(0.674089 0.73865 -0.743902 0.668288 358.23 356.427)'
          fill='#1F477D'
          stroke='#1F477D'
          strokeWidth='8'
        />
        <path
          d='M334.715 317.575C329.007 338.579 307.353 350.979 286.349 345.271C265.345 339.563 252.945 317.909 258.653 296.905C264.36 275.901 286.014 263.501 307.018 269.209C328.022 274.917 340.422 296.571 334.715 317.575Z'
          fill='#F0F5FF'
          stroke='#F0F5FF'
          strokeWidth='6'
        />
        <rect
          width='28.0016'
          height='17.6006'
          transform='matrix(0.674089 0.73865 -0.743902 0.668288 338.258 339.275)'
          fill='#3E8FFA'
        />
        <rect
          width='8.9421'
          height='24.8895'
          rx='4.47105'
          transform='matrix(0.696384 0.71767 -0.722934 0.690917 358.056 355.021)'
          fill='#1F477D'
        />
        <path
          d='M354.523 358.472L343.256 369.129L341.016 363.804L349.744 355.152L354.523 358.472Z'
          fill='#3E8FFA'
        />
        <path
          d='M249.904 290L343.369 290C344.673 297.473 344.14 301.637 340.011 309L252.703 309C248.735 300.464 248.225 293.958 249.904 290Z'
          fill='#DFEAFB'
        />
        <path
          d='M343.089 319.821C336.266 344.933 310.167 359.784 284.727 352.871C259.286 345.957 244.294 319.94 251.118 294.828C257.942 269.717 284.04 254.866 309.48 261.779C334.921 268.692 349.913 294.71 343.089 319.821Z'
          stroke='#3E8FFA'
          strokeWidth='11'
          fill='none'
        />
      </g>
      <defs>
        <filter
          id='filter0_i_511_99'
          x='0'
          y='0'
          width='509'
          height='520'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_511_99'
          />
        </filter>
        <filter
          id='filter1_d_511_99'
          x='144.5'
          y='99.4999'
          width='217.677'
          height='278'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_99'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_99'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_511_99'
          x='241.968'
          y='254.582'
          width='162.672'
          height='172.946'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_99'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_99'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
